import React from "react";
import { Cpu, ShieldAlert, LineChart, Network, Terminal } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
const engineeringValues = [{
  title: "Project Delivery",
  icon: Cpu,
  description: "Executing complex initiatives with precision and strategic alignment. We ensure your critical milestones are met through rigorous methodology and expert oversight.",
  sysCode: "SRV.DLV_01"
}, {
  title: "Risk Management",
  icon: ShieldAlert,
  description: "Identifying and mitigating enterprise-level vulnerabilities before they impact operations. Protecting your capital and reputation with proactive safeguards.",
  sysCode: "SRV.RSK_02"
}, {
  title: "Digital Transformation",
  icon: Network,
  description: "Modernizing legacy systems and workflows to drive competitive advantage. Leading the evolution of your business through purposeful technology integration.",
  sysCode: "SRV.TRN_03"
}, {
  title: "Business Analysis",
  icon: LineChart,
  description: "Translating complex data into actionable strategic insights. Deep-dive discovery and modeling to optimize organizational performance and ROI.",
  sysCode: "SRV.ANA_04"
}];
export default function OurEngineeringValues() {
  return <section data-section-id="221970" id="our-services" className="bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden selection:bg-primary/20 selection:text-primary">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/5 rounded-full blur-[120px] pointer-events-none" />

      <div className="max-w-6xl mx-auto relative z-10">
        
        {}
        <div className="mb-12 text-center md:text-left">
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-4 text-foreground uppercase">
            Strategic <span className="text-primary">Services</span>
          </h2>
          <p className="text-muted-foreground font-sans text-sm md:text-base max-w-2xl">
            Expert solutions designed for enterprise-scale impact and operational excellence across global markets.
          </p>
        </div>

        {}
        <div className="relative">
          {}
          <div className="border border-border p-3 flex items-center justify-between bg-muted/30 backdrop-blur-sm rounded-t-lg">
            <div className="flex items-center gap-3">
              <Terminal className="size-4 text-primary" />
              <span className="font-mono text-xs text-muted-foreground tracking-widest uppercase">
                STRAT_CONSULT_CORE
              </span>
            </div>
            <div className="flex gap-1.5">
              <div className="size-2.5 rounded-full bg-border" />
              <div className="size-2.5 rounded-full bg-border" />
              <div className="size-2.5 rounded-full bg-primary/60 animate-pulse" />
            </div>
          </div>

          {}
          <div className="border border-border bg-border/20 grid grid-cols-1 md:grid-cols-2 gap-px backdrop-blur-md rounded-b-lg overflow-hidden">
            {engineeringValues.map((value, i) => <Card key={i} data-index={i} className="rounded-none border-none bg-card shadow-none group relative overflow-hidden min-h-[320px] flex flex-col justify-center p-8 md:p-12 transition-all duration-500 hover:bg-muted/10 hover:-translate-y-1">
                {}
                <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-primary)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-primary)_1px,transparent_1px)] bg-[size:24px_24px] opacity-0 group-hover:opacity-5 transition-opacity duration-700 pointer-events-none" />
                
                {}
                <div className="absolute top-0 left-0 size-6 border-t-2 border-l-2 border-primary/40 opacity-0 group-hover:opacity-100 transition-all duration-500 m-4 -translate-x-2 -translate-y-2 group-hover:translate-x-0 group-hover:translate-y-0" />
                <div className="absolute bottom-0 right-0 size-6 border-b-2 border-r-2 border-primary/40 opacity-0 group-hover:opacity-100 transition-all duration-500 m-4 translate-x-2 translate-y-2 group-hover:translate-x-0 group-hover:translate-y-0" />
                
                {}
                <div className="absolute bottom-0 left-0 w-full h-0.5 bg-primary scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />

                <CardHeader className="p-0 mb-6 relative z-10 flex flex-row items-start justify-between space-y-0">
                  <div>
                    <value.icon className="size-10 text-primary mb-5 stroke-[2] group-hover:scale-110 transition-transform duration-500" />
                    <CardTitle className="font-default text-2xl font-bold tracking-wide text-foreground">
                      {value.title}
                    </CardTitle>
                  </div>
                  <span className="font-mono text-[10px] text-muted-foreground/50 tracking-widest group-hover:text-primary/50 transition-colors">
                    {value.sysCode}
                  </span>
                </CardHeader>
                
                <CardContent className="p-0 relative z-10">
                  <p className="text-muted-foreground leading-relaxed font-sans text-sm md:text-base group-hover:text-foreground/90 transition-colors duration-300">
                    {value.description}
                  </p>
                </CardContent>
              </Card>)}
          </div>
        </div>
        
      </div>
    </section>;
}